import { connect } from "react-redux";

import {
  selectModal,
  hideModal,
  showModal,
  selectLastX,
  selectLastY,
  setLastX,
  setLastY,
  selectLastWidth,
  selectLastHeight,
  setLastWidth,
  setLastHeight
} from "~/store/ducks/domain/ui/modal";
import { setShapeType, setDrawingMode } from "~/store/ducks/application/fabric";

import ModalPortal from "./Portal";

const mapStateToProps = state => ({
  ...selectModal(state),
  lastX: selectLastX(state),
  lastY: selectLastY(state),
  lastWidth: selectLastWidth(state),
  lastHeight: selectLastHeight(state)
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => {
    dispatch(setDrawingMode(false));
    dispatch(setShapeType(null));
    dispatch(hideModal());
  },
  showModal: (kind, props) => dispatch(showModal(kind, props)),
  setLastX: x => dispatch(setLastX(x)),
  setLastY: y => dispatch(setLastY(y)),
  setLastWidth: width => dispatch(setLastWidth(width)),
  setLastHeight: height => dispatch(setLastHeight(height))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalPortal);
